var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _path, _circle6, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 690,
    height: 690,
    viewBox: "0 0 690 690",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 345,
    y: 344,
    width: 311,
    height: 311,
    fill: "url(#paint0_angular_690_1284)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 345,
    r: 137.5,
    stroke: "#FF6634",
    strokeOpacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 345,
    r: 98.5,
    stroke: "#FF6634"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 345,
    r: 190.5,
    stroke: "#595968",
    strokeOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 345,
    r: 269.5,
    stroke: "#595968",
    strokeOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 345,
    cy: 345,
    r: 344.5,
    stroke: "#595968",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.037 605.344C645.288 640.432 609.743 661.788 574.646 653.038C539.565 644.29 518.209 608.749 526.962 573.661C535.706 538.568 571.251 517.212 606.338 525.96C641.432 534.708 662.788 570.253 654.04 605.344H654.037Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 345,
    r: 66,
    fill: "url(#paint1_linear_690_1284)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379 315H330.86C324.118 315 317.893 318.917 315.292 325.125C312.691 331.329 314.089 338.418 318.848 343.172L329.856 354.168C330.285 354.596 329.983 355.331 329.374 355.331H314.001V374H362.141C368.878 374 375.108 370.083 377.709 363.87C380.31 357.657 378.907 350.577 374.153 345.828L363.145 334.832C362.716 334.404 363.018 333.669 363.627 333.669H379V315ZM336.919 353.949L346.379 344.5L355.838 353.949C356.35 354.46 355.989 355.331 355.263 355.331H337.494C336.773 355.331 336.413 354.46 336.919 353.949ZM346.379 344.5L336.919 335.051C336.408 334.54 336.768 333.669 337.494 333.669H355.263C355.984 333.669 356.345 334.54 355.838 335.051L346.379 344.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_690_1284",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(500.5 499.5) rotate(-136.539) scale(212.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C0C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF6634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_690_1284",
    x1: 295.544,
    y1: 279,
    x2: 412,
    y2: 377.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC96FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF6535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5757"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.1bad925705f86117a48729361c7fd762.svg";
export { ForwardRef as ReactComponent };